<template>
    <div class="d-flex">
        <zoezi-site-selector :compact="true" class="justify-end mx-1" />
        <template v-if="showLanguage && hasLanguage">
            <zoezi-language-menu :show-label="false" :compact="true" class="mx-1 align-center" />
        </template>
        <zoezi-account-button />
    </div>
</template>

<script>
import ZoeziSiteSelector from '../views/SiteSelector.vue'
import ZoeziAccountButton from '../views/AccountButton.vue'
import ZoeziLanguageMenu from '../views/LanguageMenu.vue'
export default {
    name: 'zoezi-site-selector-and-account-button',

    zoezi: {
        title: 'Site Selector and Account Button',
        icon: 'mdi-account-circle'
    },

    components: {
        ZoeziSiteSelector,
        ZoeziAccountButton,
        ZoeziLanguageMenu
    },

    props: {
        showLanguage: {
            title: 'Show language selector',
            type: Boolean,
            default: true
        }
    },

    computed: {
        hasLanguage() {
            return this.$store.state.settings?.hasLanguage;
        }
    }
}
</script>
